var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 17.27 13.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M18.543,6H4.727A1.725,1.725,0,0,0,3.009,7.727L3,18.089a1.732,1.732,0,0,0,1.727,1.727H18.543a1.732,1.732,0,0,0,1.727-1.727V7.727A1.732,1.732,0,0,0,18.543,6Zm0,3.454-6.908,4.318L4.727,9.454V7.727l6.908,4.318,6.908-4.318Z",
    transform: "translate(-3 -6)",
    fill: "#c3cad8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.ac3c733c3d79e7e87afa76e4cd322f9f.svg";
export { ForwardRef as ReactComponent };